import { render } from "./modalFilterDropdown.vue?vue&type=template&id=5fed178e"
import script from "./modalFilterDropdown.vue?vue&type=script&lang=js"
export * from "./modalFilterDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script